import React from "react";
import Dashboard from "../@Components/Dashboard";
import { Col, Content, Grid, Row } from "rsuite";
import LeadList from "../@Components/Leads/LeadList";
import LeadPrimaryLeadStatCards from "../@Components/Visualization/LeadPrimaryLeadStatCards";
import Title from "../@Components/Title";

const Leads: React.FC = () => {
  return (
    <Dashboard>
      <Title title="Transactions" />
      <LeadPrimaryLeadStatCards />
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "100%" }}>
              <Title title="Browse Leads" />
              <LeadList height={750} />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default Leads;
